import React, {useEffect, useState} from "react";
import {Row, Col, Drawer, Form, Input, Button, Select, message} from "antd";
import {MenuOutlined} from "@ant-design/icons";
import {useModel} from "../../../models";

const DetailForm = () => {
    const [form] = Form.useForm();

    const [{warehouseDict, positionDict}] = useModel("cmDict");

    const [{
        searchParam,
        stockPage,
        stockList,
        stockListSelectedRowKeys
    }, {
        setShiftVisible,
        shift,
        setStockListSelectedRowKeys,
        loadStockList,
    }] = useModel("stockStatistic")

    useEffect(() => {
        const selectedStock = stockList.find(el => el.key === stockListSelectedRowKeys[0]);
        if (selectedStock) {
            form.setFieldsValue({...selectedStock, moveNum: selectedStock.inventoryNum});
        }
    }, [stockListSelectedRowKeys])

    const [targetWarehouseOptions, setTargetWarehouseOptions] = useState([]);
    const [targetShelfCodeOptions, setTargetShelfCodeOptions] = useState([]);
    useEffect(() => {
        const mappedOptions = warehouseDict.map(el => ({
            key: el.key,
            label: el.label,
            value: el.value,
        }));
        setTargetWarehouseOptions(mappedOptions);
    }, [warehouseDict]);

    const onTargetWarehouseChange = (e) => {
        const mappedOptions = positionDict.filter(el => el.warehouseId === e)
            .map(el => ({
                key: el.key,
                label: el.label,
                value: el.value,
            }))
        setTargetShelfCodeOptions(mappedOptions);
        form.setFieldsValue({targetShelfCode: null})
    }
    const onFinish = () => {
        const selectedStock = stockList.find(el => el.key === stockListSelectedRowKeys[0]);
        const {id, materialId = null, materialCode,shelfCode} = selectedStock;
        const targetWarehouse = form.getFieldValue("targetWarehouse");
        const targetShelfCode = form.getFieldValue("targetShelfCode");
        // return console.log(targetShelfCode)
        const selectedPosition = targetShelfCodeOptions.find(el => el.value === targetShelfCode);
        if(selectedPosition.label === shelfCode){
            return message.error("原货位和目标货位相同，不能进行移库操作，请选择对应的不同货位")
        }
        const {key, label} = selectedPosition;        
        const requestParam = {
            id,
            materialId,
            materialCode,
            warehouseId: targetWarehouse,
            shelfId: key,
            shelfCode: label,
            moveNum: selectedStock.inventoryNum,
        }
        shift({showMsg: true, data: requestParam}).then((ret) => {
            // setStockListSelectedRowKeys([]);
            const {pageNum, pageSize} = stockPage
            const data = {...searchParam, pageNum, pageSize};
            loadStockList({showMsg: false, data});
            setShiftVisible(false)
        })
    }

    const onClose = () => {
        setShiftVisible(false);
    }
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{span: 8}}
            onFinish={onFinish}
        >
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="materialCode"
                        label="商品编号"
                    >
                        <Input disabled={true} placeholder="商品编号"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="materialName"
                        label="商品名称"
                    >
                        <Input disabled={true} placeholder="商品名称"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="warehouseName"
                        label="原仓库"
                    >
                        <Input disabled={true} placeholder="原仓库"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="targetWarehouse"
                        label="目标仓库"
                        rules={[{required: true, message: '目标仓库不能为空',}]}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择目标仓库"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={targetWarehouseOptions}
                            onChange={onTargetWarehouseChange}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="shelfCode"
                        label="原货位"
                    >
                        <Input disabled={true} placeholder="原货位"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="targetShelfCode"
                        label="目标货位"
                        rules={[{required: true, message: '目标货位不能为空',}]}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择目标货位号"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={targetShelfCodeOptions}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="inventoryNum"
                        label="现有数据"
                    >
                        <Input disabled={true} placeholder="现有数据"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="moveNum"
                        label="移库数量"
                    >
                        <Input disabled={true} placeholder="移库数量"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 24,
                        }}
                    >
                        <Button type="primary" htmlType="submit">
                            移库
                        </Button>
                        <Button htmlType="button" onClick={onClose} className="margin-left-8">
                            关闭
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
}

const Title = () => {
    return (
        <h3>
            <MenuOutlined/>
            <span className="margin-left-8">移库</span>
        </h3>
    )
}
export default function () {
    const [{shiftVisible}, {setShiftVisible}] = useModel("stockStatistic")
    const onClose = () => {
        setShiftVisible(false);
    }
    return (
        <Drawer
            title={<Title/>}
            placement="right"
            closable={true}
            onClose={onClose}
            visible={shiftVisible}
            width={750}
        >
            <DetailForm/>
        </Drawer>
    )
}